import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import AudioAnalyser from "./AudioAnalyser";

class SpeakAudioTest extends Component {
  constructor(props) {
    super(props);
    this.state = { audio: null };
    this.toggleMicrophone = this.toggleMicrophone.bind(this);
  }

  async componentDidMount() {
    try {
      await this.getMicrophone();
  
    } catch (error) {
      console.error("Microphone access denied:", error);
      this.setState({ audio: null });
    }
  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    this.setState({ audio });
  }

  stopMicrophone() {
    this.state.audio.getTracks().forEach((track) => track.stop());
    this.setState({ audio: null });
  }

  toggleMicrophone() {
    if (this.state.audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  }

  render() {
    return (
      <Row className="pt-2 f-13 align-items-center">

        <Col className="col-12">
          {this.state.audio ? (
            <AudioAnalyser audio={this.state.audio} width={168} height={55} modalTest={true} />
          ) : null}
        </Col>
      </Row>
    );
  }
}

export default SpeakAudioTest;
